import React, { Component } from 'react';
import CountUp from 'react-countup';

class BannerSection extends Component {
    render() {
        return (
            <div className="section-banner-wrap">
                <div className="section-banner-bg"></div>
                <div className="section-banner-filter"></div>
                <div className="section-banner-detail gapt-96 sm-gapt-64 sm-gapb-64">
                    <div className="section-banner-title gapb-8">งานวิจัยและนวัตกรรมมหาวิทยาลัยแม่โจ้</div>
                    <div className="section-banner-text gapb-24">โครงการจับคู่งานวิจัยและนวัตกรรมผลงานของบัณฑิตศึกษาสำหรับผู้ประกอบการหรือชุมชน</div>
                    <div className="is-row is-sm-row section-banner-stat">
                        <div className="section-banner-stat-item">
                            <div className="section-banner-stat-title gapb-2">ผลงาน</div>
                            <div className="section-banner-stat-text"><CountUp separator=',' start={0} end={500} duration={2} />+ โครงการ</div>
                            <div className="vl"></div>
                        </div>
                        <div className="section-banner-stat-item">
                            <div className="section-banner-stat-title gapb-2">หมวดหมู่</div>
                            <div className="section-banner-stat-text"><CountUp separator=',' start={0} end={100} duration={2} />+ ประเภท</div>
                            <div className="vl"></div>
                        </div>
                        <div className="section-banner-stat-item">
                            <div className="section-banner-stat-title gapb-2">บุคลากร</div>
                            <div className="section-banner-stat-text"><CountUp separator=',' start={0} end={1500} duration={2} />+ ชีวิต</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BannerSection;
